import { Component, OnInit } from '@angular/core';
import { AgreementDto } from '@models/users/agreement.dto';
import { AgreementService } from '@services/agreement.service';
import { MessageService } from '@services/message.service';
import { MenuItem, PrimeIcons } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { FileUploadHandlerEvent } from 'primeng/fileupload';
import { catchError } from 'rxjs';

@Component({
  selector: 'ebs-agreement',
  templateUrl: './agreement.component.html',
  styleUrls: ['./agreement.component.scss'],
})
export class AgreementComponent implements OnInit {
  public users: AgreementDto[] = [];

  public search: string = '';

  public currentlyEditing: AgreementDto | null = null;

  public dialogAgreement: AgreementDto | undefined;

  public items: MenuItem[] = [
    {
      command: () => this.exportToExcel(),
      icon: PrimeIcons.FILE_EXCEL,
    },
    {
      command: () => this.exportToPdf(),
      icon: PrimeIcons.FILE_PDF,
    },
  ];

  public fileSrc: any = undefined;
  public showPreview: boolean = false;

  constructor(
    private agreementService: AgreementService,
    public dialogService: DialogService,
    private messageService: MessageService,
  ) {}

  async onBasicUploadAuto(
    agreement: AgreementDto,
    event: FileUploadHandlerEvent,
  ) {
    this.agreementService
      .uploadAgreementPoster(agreement, await event.files[0].arrayBuffer())
      .subscribe();
  }

  previewFile(agreement: AgreementDto) {
    this.agreementService
      .downloadAgreementPoster(agreement.agreementId!)
      .subscribe(async (result: any) => {
        this.fileSrc = result;
        this.showPreview = true;
      });
  }

  closePreview() {
    this.fileSrc = undefined;
    this.showPreview = false;
  }

  openVsibilityDialog(editing: AgreementDto) {
    this.dialogAgreement = editing;
  }

  saveVsibility() {
    this.saveAgreementChanges(this.dialogAgreement!);
  }

  ngOnInit() {
    this.loadAgreements();
  }

  loadAgreements() {
    this.agreementService.getAgreements().subscribe((users) => {
      this.users = users;
    });
  }

  exportToExcel() {}

  exportToPdf() {}

  createNewAgreement() {
    this.users.splice(0, 0, {
      name: '',
      lastName: '',
      email: '',
      phone: '',
      jobType: '',
      notes: '',
      description: '',
    });

    this.currentlyEditing = this.users[0];
  }

  removeAgreement(agreement: AgreementDto) {
    this.agreementService
      .removeAgreement([agreement])
      .pipe(
        catchError((err) => {
          this.currentlyEditing = null;
          this.messageService.error(
            'Rimozione convenzione',
            'Errore durante la rimozione',
          );
          return err;
        }),
      )
      .subscribe((res) => {
        this.currentlyEditing = null;
        this.messageService.success(
          'Rimozione convenzione',
          'Rimozione avvenuta con successo',
        );
      });
  }

  editAgreement(agreement: AgreementDto | null) {
    if (
      agreement === null &&
      (this.currentlyEditing?.agreementId === undefined ||
        this.currentlyEditing?.agreementId === null)
    ) {
      this.users.splice(0, 1);
    }
    this.currentlyEditing = agreement;
  }

  modifySubscrber() {
    if (this.currentlyEditing !== null) {
      this.saveAgreementChanges(this.currentlyEditing);
    }
  }

  saveAgreementChanges(agreement: AgreementDto) {
    this.agreementService
      .modifyAgreement([agreement])
      .pipe(
        catchError((err) => {
          this.currentlyEditing = null;
          this.dialogAgreement = undefined;
          this.messageService.error(
            'Modifica convenzione',
            'Errore durante la modifica',
          );
          return err;
        }),
      )
      .subscribe((res) => {
        this.currentlyEditing = null;
        this.dialogAgreement = undefined;
        this.messageService.success(
          'Modifica convenzione',
          'Modifica avvenuta con successo',
        );
      });
  }
}
